<template>
  <div class="tag">
    <SectionTitle zh="标注任务" en="TAGGING TASK"></SectionTitle>
    <TabSecond :names="[$t('data.image'), $t('data.wav'), $t('data.text'), $t('data.video')]" @handSelect="selectTag"></TabSecond>
    <DataTag class="container" :type="curDataType" :windowType="windowType"></DataTag>
  </div>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'
import TabSecond from '@/components/TabSecond'
import DataTag from '@/components/DataTag'

import { getBrowser } from '@/assets/js/unit'

export default {
  name: 'PlatformTag',
  components: {
    SectionTitle,
    TabSecond,
    DataTag
  },
  data () {
    return {
      curDataType: 1,
      windowType: false
    }
  },
  created () {
    this.getWindowWid()
  },
  mounted () {
    window.onresize = () => {
      this.getWindowWid()
    }
  },
  methods: {
    getWindowWid () {
      this.windowType = getBrowser()
    },
    selectTag (type) {
      this.curDataType = type + 1
    }
  }
}
</script>

<style lang="less" scoped>
.tag {
  background-color: #F2F2F2;
  padding: 0 0 5rem;
}
@media (max-width: 1300px) {
  .container {
    width: 70%;
  }
}
</style>
